import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';


@Pipe({name: 'convertTZToUTC'})
export class ConvertTZToUTCPipe implements PipeTransform {
  transform(dateTZ: string, timezone: any = moment.tz.guess(), formatStr: string = 'YYYY-MM-DD HH:mm:ss'): any {
    if (!dateTZ) { return null; }

    try {
      const currDate = moment.tz(dateTZ, timezone);
      if (currDate) {
        return currDate.tz('UTC').format(formatStr);
      } else {
        return dateTZ;
      }
    } catch (e) {
      return dateTZ;
    }
  }
}
